import React from 'react';
import './service.scss';
import Breadcrumb from '../../shared/breadcrumb/breadcrumb.js';
import { useParams } from 'react-router-dom';
import { useStore } from 'hooks/useStore';

export function Service() {
  const params = useParams();
  var productId = +params.id;

  const {
    state: {
      service: {
        products
      }
    }
  } = useStore();

  var product = products.find(p => p.id === productId);

  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/services', text: 'Платные услуги' },
          { to: `/services/medical-services/${product.id}`, text: product.name }
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <h1>{product.name}</h1>
        </div>
        <div>
          <div className="card add_bottom_45">
            <div className="card-body">
              <div
                className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                dangerouslySetInnerHTML={{ __html: product.description }}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Service;
